import React from "react"
import { Container, Row, Col } from "reactstrap"
import saudi from "assets/images/flags/saudi.svg"
import { useTranslation } from "react-i18next"

const Footer = () => {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {new Date().getFullYear()} © {t("Wulooj")}.
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                {t("Designed with")}{" "}
                <i style={{ color: "red" }} className="mx-1 bx bxs-heart"></i>{" "}
                {t("in")}{" "}
                <img src={saudi} width={20} height={20} className="mx-1" />
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
